// constants
import { ENTITIES_STATUSES } from 'constants/index'
// themes
import { colors } from 'themes'
// utils
import find from 'lodash/fp/find'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import type { Moment } from 'moment'
import pipe from 'lodash/fp/pipe'
import { generateUserName } from './user'
import { safeGetOr } from './fp'
// types
import { IPlan, IPosition, IUser } from 'types/graphql'

export const getChipColor = (dueDate: Moment, statusOrCompletence: number | string): string => {
  if (!dueDate) {
    return colors.gray290
  }

  if (statusOrCompletence === 100 || statusOrCompletence === ENTITIES_STATUSES.COMPLETE) {
    return colors.green300
  }

  if (moment().isAfter(dueDate, 'day')) {
    return colors.red200
  }
  if (moment().isBefore(dueDate, 'day')) {
    return colors.gray350
  }
  if (moment().isSame(dueDate, 'day')) {
    return colors.orange300
  }
}

export const getOwnedBy = (position: IPosition, user: IUser): string => {
  if (user) {
    return generateUserName(user)
  }

  if (position) {
    return position.description
  }

  return 'N/A'
}

export const getTableHeader = (name, fields, defaultValue) => {
  const header = get(fields.filter(field => field.name === name), '[0].label')

  if (isEmpty(fields) || !header) {
    return defaultValue
  }

  return header.toUpperCase()
}

export const getPlanFromEntity = (entity: any): IPlan => {
  return pipe(
    safeGetOr<any, any, any>([], 'planItems.data'),
    find(({ referenced }) => !referenced),
    safeGetOr<any, any, any>({}, 'plan')
  )(entity)
}
